// contexts/PublicFormPreviewWrapper.jsx
import React, { useEffect } from "react";
import { FormProvider } from "./FormContext";
import InnerPublicFormPreview from "../pages/InnerPublicFormPreview";

/**
 * PublicFormPreviewWrapper.jsx is the outermost wrapper for public form previews.
 * It provides the FormProvider context and delegates the preview hydration and rendering
 * to InnerPublicFormPreview, which handles Firestore validation and sessionStorage hydration.
 */
const PublicFormPreviewWrapper = () => {
  useEffect(() => {
    //console.log("🚀 [PublicFormPreviewWrapper] Mounted");

    // Dump full sessionStorage state (keys + values)
    try {
      //console.log("🧠 [PublicFormPreviewWrapper] SessionStorage snapshot:");
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        const value = sessionStorage.getItem(key);
        //console.log(`   • ${key}:`, value?.slice(0, 100) || "[null]");
      }
    } catch (err) {
      console.error("❌ [PublicFormPreviewWrapper] Error reading sessionStorage:", err);
    }
  }, []);

  return (
    <FormProvider>
      <InnerPublicFormPreview />
    </FormProvider>
  );
};

export default PublicFormPreviewWrapper;
